<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_chatbot_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>
<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_appearance" | translate }}
                </label>
                <div class="col-xs-12">
                    <div class="btn-group d-flex">
                        <div
                            class="btn btn-grey w-100"
                            [class.active]="settings().type === EButtonType.icon"
                            (click)="onSwitchButtonType(EButtonType.icon)"
                        >
                            {{ "control_appearance_icon" | translate }}
                        </div>
                        <div
                            class="btn btn-grey w-100"
                            [class.active]="settings().type === EButtonType.button"
                            (click)="onSwitchButtonType(EButtonType.button)"
                        >
                            {{ "control_appearance_button" | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_button_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" [formField]="styleType">
                        <option [value]="EButtonStyleType.classic">
                            {{ "control_appearance_classic" | translate }}
                        </option>
                        <option [value]="EButtonStyleType.primary">
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option [value]="EButtonStyleType.secondary">
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [value]="EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <sp-radio-group
                        [selected]="settings().buttonSize"
                        [type]="ERadioGroupType.size"
                        (changeSelectedEvent)="setButtonSize($any($event))"
                    />
                </div>
            </div>

            @if (settings().styleType === EButtonStyleType.custom) {
                <div class="mb-20">
                    <web-custom-button
                        [parentBase]="$any(settings().buttonBase)"
                        [parentHover]="$any(settings().buttonHover)"
                        [advancedBorderSettings]="$any(settings().advancedBorderSettings)"
                        [isIndependentCorners]="settings().isIndependentCorners"
                        [radiusSettings]="$any(settings().advancedRadius)"
                        [isAdvancedRadius]="true"
                        (valueChangeEvent)="customButtonChangeHandler($event)"
                    />
                </div>
            }
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
